var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMainpagePartnerIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 168,
    height: 170,
    viewBox: "0 0 168 170",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mainpage_partner_icon1",
    transform: "translate(-6077.729 -5942.38) rotate(-45)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "contact_us4",
    transform: "translate(-3206.481 11945.938) rotate(-135)",
    opacity: 0.614
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_153051",
    "data-name": "\\uC0AC\\uAC01\\uD615 153051",
    width: 36,
    height: 36,
    transform: "translate(0 4602)",
    fill: "#f1f3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_153053",
    "data-name": "\\uC0AC\\uAC01\\uD615 153053",
    width: 36,
    height: 36,
    transform: "translate(-66 4668)",
    fill: "#f1f3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_153052",
    "data-name": "\\uC0AC\\uAC01\\uD615 153052",
    width: 36,
    height: 36,
    transform: "translate(-33 4635)",
    fill: "#f1f3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_153056",
    "data-name": "\\uC0AC\\uAC01\\uD615 153056",
    width: 36,
    height: 36,
    transform: "translate(0 4668)",
    fill: "#f1f3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_153054",
    "data-name": "\\uC0AC\\uAC01\\uD615 153054",
    width: 36,
    height: 36,
    transform: "translate(33 4635)",
    fill: "#f1f3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_153055",
    "data-name": "\\uC0AC\\uAC01\\uD615 153055",
    width: 36,
    height: 36,
    transform: "translate(66 4602)",
    fill: "#f1f3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "contact_us4-2",
    "data-name": "contact_us4",
    transform: "translate(-3158.398 11897.854) rotate(-135)",
    opacity: 0.614
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_153053-2",
    "data-name": "\\uC0AC\\uAC01\\uD615 153053",
    width: 36,
    height: 36,
    transform: "translate(-66 4668)",
    fill: "#f1f3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_153052-2",
    "data-name": "\\uC0AC\\uAC01\\uD615 153052",
    width: 36,
    height: 36,
    transform: "translate(-33 4635)",
    fill: "#f1f3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_153056-2",
    "data-name": "\\uC0AC\\uAC01\\uD615 153056",
    width: 36,
    height: 36,
    transform: "translate(0 4668)",
    fill: "#f1f3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_153054-2",
    "data-name": "\\uC0AC\\uAC01\\uD615 153054",
    width: 36,
    height: 36,
    transform: "translate(33 4635)",
    fill: "#f1f3f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_153055-2",
    "data-name": "\\uC0AC\\uAC01\\uD615 153055",
    width: 36,
    height: 36,
    transform: "translate(66 4602)",
    fill: "#f1f3f7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainpagePartnerIcon1);
export default __webpack_public_path__ + "static/media/mainpage_partner_icon1.3b263ceecc8eeab30c7e2ab2bb11a351.svg";
export { ForwardRef as ReactComponent };